import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { NewLoading } from 'components'

const useStyle = makeStyles(() => ({
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
}));

export default function LoadingPage({customStyle}) {
  const classes = useStyle();
  return (
    <div style={customStyle ? customStyle : {}} className={clsx(classes.container)}>
      <NewLoading type="pages" />
    </div>
  );
}
